
















































import { mapGetters } from 'vuex';

import { CONFIG_CONSTS } from '../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../store/context/context.consts';

import { UiRippleInk } from '../keen-ui';
import DomainSelector from './domain-selector.component.vue';

export enum AnimationStepEnum {
  INSTANCE,
  ENVIRONMENT,
  DOMAIN
}

export enum LogoTypeEnum {
  IMAGOTYPE = 'imagotype',
  ISOTYPE = 'isotype'
}

export default {
  name: 'navigation-menu-header',
  props: {
    domains: {
      type: Array,
      required: true
    },
    selectedDomain: {
      type: String,
      required: true
    },
    collapsible: Boolean,
    collapsed: Boolean,
    collapsedInState: Boolean,
    disabled: Boolean,
    animationDurationInMillis: Number
  },
  components: {
    UiRippleInk,
    DomainSelector
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    componentClasses: function () {
      return {
        'epb-navigation-menu-header--collapsible': this.collapsible,
        'epb-navigation-menu-header--collapsed': this.collapsed,
        'epb-navigation-menu-header--collapsed-in-state': this.collapsedInState
      };
    },
    instanceName: function (): string {
      return (this.instanceConfig.prettyName || this.instanceConfig.instanceId);
    }
  },
  data: function () {
    return {
      assetsBaseUrl: 'https://assets.empathybroker.com/resources/media/customers/',
      AnimationStepEnum,
      LogoTypeEnum
    };
  },
  methods: {
    getItemStyle: function (index: number) {
      let animationSteps = 3;
      if (this.collapsed) {
        animationSteps -= 1;
      }
      const itemTransitionDurationInMillis = (this.animationDurationInMillis / animationSteps);
      return {
        transitionDuration: `${ itemTransitionDurationInMillis }ms`,
        transitionDelay: `${ (itemTransitionDurationInMillis * index) }ms`
      };
    },
    getLogoUrl: function (logoType: LogoTypeEnum): string {
      return ((!!this.instanceConfig.logoUrls && this.instanceConfig.logoUrls[logoType]) ||
        this.getDefaultLogoUrl(logoType, this.instanceConfig.instanceId));
    },
    getDefaultLogoUrl(logoType: LogoTypeEnum, instanceId: string): string {
      const logoFileName = {
        [LogoTypeEnum.IMAGOTYPE]: 'logo.svg',
        [LogoTypeEnum.ISOTYPE]: 'isotype.png'
      }[logoType];
      return `${ this.assetsBaseUrl }${ instanceId }/${ logoFileName }`;
    },
    onImageError: function (logoType: LogoTypeEnum, event): void {
      event.target.src = this.getDefaultLogoUrl(logoType, 'empathy');
    }
  }
};
